// Tracks recently viewed products in localStorage (most-recent first, max 12).
const KEY = "xm_recently_viewed";
const MAX = 12;

export const trackRecentlyViewed = (productId) => {
  if (!productId) return;
  try {
    const cur = JSON.parse(localStorage.getItem(KEY) || "[]");
    const next = [productId, ...cur.filter((id) => id !== productId)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* ignore */ }
};

export const getRecentlyViewed = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};
